/* Stylesheet */

.resizer_button {
  position: absolute;
  right: 16px;
  bottom: 16px;
  cursor: ns-resize;
  z-index: 1000;

  .icon {
    height: 18px;
    width: 18px;
    color: var(--ion-color-gray-primary);
  }
}
